import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createClinicalSite } from '../services/clinical_sites';

export const useCreateClinicalSite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createClinicalSite,
    onSuccess: (data) => {
      // Invalidate and refetch clinical sites
      queryClient.invalidateQueries({ queryKey: ['clinicalSites'] });
      
      toast.success('Clinical site created successfully!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    },
    onError: (error) => {
      console.error('Error creating clinical site:', error);
      toast.error('Error creating clinical site. Please try again.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    },
  });
};
